import { deleteFile, uploadFile, updateContactApi } from 'api';
import { NOTIF_CONTACT_UPDATE_ERROR } from 'constants/notificationMsg';
import { NOTIF_CONTACT_UPDATE_SUCCESS } from 'constants/notificationMsg';
import makeNewContactObj from './makeNewContactObj';

async function updateContact(setIsLoading, contact, notifySuccess, notifyError, fetchContacts) {
	let newFileId;
	setIsLoading(true);

	try {
		if (contact.image.file !== '') {
			const resUpload = await uploadFile(contact.image.file);
			if (resUpload.Success) {
				newFileId = resUpload.Payload.Id;
			}
		}

		const contObj = makeNewContactObj(contact, newFileId);
		const resUpdate = await updateContactApi(contObj);

		if (resUpdate.Success) {
			if (contact.vFileId !== '') {
				await deleteFile(contact.vFileId);
			}
			await fetchContacts();
			notifySuccess(NOTIF_CONTACT_UPDATE_SUCCESS);
		} else {
			notifyError(NOTIF_CONTACT_UPDATE_ERROR);
		}
	} catch (error) {
		notifyError(error.message);
	} finally {
		setIsLoading(false);
	}
}

export default updateContact;
